module.exports = __webpack_public_path__ + "static/Skeleton-b959c331c43143258e4117fa8705b906.jpg";